import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LegalLinks } from "@app/components/LegalLinks.tsx";
import { api } from "@app/api/client.ts";
import type { PlayerStats } from "@shared/types";

export function Stats() {
  const [stats, setStats] = useState<PlayerStats | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    void api
      .stats()
      .then(setStats)
      .catch(() => setError(true));
  }, []);

  const maxCount = stats ? Math.max(1, ...stats.distribution.map((d) => d.count)) : 1;

  return (
    <section className="screen screen--scroll" aria-labelledby="statsTitle">
      <div className="results">
        <h1 id="statsTitle" className="scorebox__k top">
          Tus estadísticas
        </h1>
        {error ? <p className="status">No hemos podido cargar tus estadísticas.</p> : null}
        {!stats && !error ? <p className="status">Cargando…</p> : null}
        {stats ? (
          <>
            <div className="stats-grid">
              <div className="stat">
                <b>{stats.played}</b>
                <span>Jugadas</span>
              </div>
              <div className="stat">
                <b>{stats.average}</b>
                <span>Media</span>
              </div>
              <div className="stat">
                <b>{stats.best}</b>
                <span>Mejor</span>
              </div>
              <div className="stat">
                <b>{stats.bestStreak}</b>
                <span>Mejor racha</span>
              </div>
            </div>
            <div className="scorebox">
              <div className="scorebox__k">Distribución por tramos</div>
              <div className="hist">
                {stats.distribution.map((bucket) => (
                  <div className="hist__row" key={bucket.from}>
                    <span>
                      {bucket.from}–{bucket.to}
                    </span>
                    <span className="hist__bar" style={{ width: `${(bucket.count / maxCount) * 100}%` }} />
                    <span>{bucket.count}</span>
                  </div>
                ))}
              </div>
            </div>
            <p className="actions__hint">
              Tu historial está ligado a este dispositivo. Si borras los datos del navegador o
              cambias de dispositivo, perderás la racha y las estadísticas.
            </p>
          </>
        ) : null}
        <Link className="cta cta--ghost" to="/">
          Volver al inicio
        </Link>
        <LegalLinks />
      </div>
    </section>
  );
}
